"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _smallBanner = babelHelpers.interopRequireWildcard(require("./smallBanner"));

var _decorators = require("decorators");

var _postToEmailModal = babelHelpers.interopRequireDefault(require("modals/postToEmail-modal"));

var _react = babelHelpers.interopRequireDefault(require("react"));

var _class;

var FeedbackStack =
/*#__PURE__*/
function (_SmallBannerBlock) {
  babelHelpers.inherits(FeedbackStack, _SmallBannerBlock);

  function FeedbackStack() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, FeedbackStack);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(FeedbackStack)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    _this.extraAtributes = {
      href: 'javascript:void(0)',
      onClick: _this.clickHandler
    };
    return _this;
  }

  babelHelpers.createClass(FeedbackStack, [{
    key: "getChildren",
    value: function getChildren() {
      return _react.default.createElement(FeedbackHeader, this.header);
    }
  }]);
  return FeedbackStack;
}(_smallBanner.default);

exports.default = FeedbackStack;
var FeedbackHeader = (_class =
/*#__PURE__*/
function (_SmallHeader) {
  babelHelpers.inherits(FeedbackHeader, _SmallHeader);

  function FeedbackHeader() {
    babelHelpers.classCallCheck(this, FeedbackHeader);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(FeedbackHeader).apply(this, arguments));
  }

  babelHelpers.createClass(FeedbackHeader, [{
    key: "clickHandler",
    value: function clickHandler(event) {
      _postToEmailModal.default.defaultType = 'Suggest a Course';

      _postToEmailModal.default.show();

      event.preventDefault();
    }
  }, {
    key: "showButton",
    value: function showButton() {
      return _react.default.createElement("div", {
        className: "container"
      }, _react.default.createElement("a", {
        className: "btn-secondary",
        href: "javascript:void(0)",
        onClick: this.clickHandler
      }, this.buttonTitle));
    }
  }]);
  return FeedbackHeader;
}(_smallBanner.SmallHeader), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "clickHandler", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "clickHandler"), _class.prototype)), _class);